import React, { useState } from "react";
import { string, func, bool } from "prop-types";
import { Link } from "react-router-dom";
import * as style from "./styles.module.scss";
import Spinner from "../../common/Spinner";

const FormPDFResource = ({
  route,
  title,
  description,
  downloadPDFFile,
  hasFile,
}) => {
  const [loading, setLoading] = useState(false);

  const downloadHandler = async () => {
    const fileFound = hasFile;
    if (fileFound) {
      setLoading(true);
      await downloadPDFFile(true);
      setLoading(false);
    }
  };

  const button = (bText, isLink = false) => (
    <button
      disabled={loading ? "disabled" : ""}
      className={`btn btn-block btn-primary ${style.resource__button}`}
      onClick={() => (!isLink ? downloadHandler() : null)}
    >
      {loading ? <Spinner /> : bText}
    </button>
  );

  const enterDetailsButton = (
    <Link
      to={`/profile/edit/resources/${route}`}
      style={{ textDecoration: "none" }}
    >
      {button("Enter details", true)}
    </Link>
  );

  const downloadButton = button("Download");

  return (
    <div className={style.resource__wrapper}>
      <h4 className={style.resource__title}>{title}</h4>
      <p className={style.resource__description}>
        <b>{description}</b>
      </p>
      <span className="d-flex justify-content-end">
        {hasFile ? downloadButton : enterDetailsButton}
      </span>
    </div>
  );
};

FormPDFResource.propTypes = {
  title: string.isRequired,
  description: string.isRequired,
  downloadPDFFile: func,
  hasFile: bool,
  route: string,
};

export default FormPDFResource;
